/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Gets the difference between an original object and an updated object.
 * @param original - The original object.
 * @param updated - The updated object with new values.
 * @returns An object containing only the keys with different values.
 * @throws {Error} - Throws an error if invalid objects.
 */
export function getObjectDiff(original, updated) {
    if (typeof original !== "object" ||
        typeof updated !== "object" ||
        original === null ||
        updated === null) {
        throw new Error("Both arguments must be non-null objects.");
    }
    const diff = {};
    for (const key in updated) {
        const originalValue = original[key];
        const updatedValue = updated[key];
        if (typeof originalValue === "object" &&
            typeof updatedValue === "object" &&
            originalValue !== null &&
            updatedValue !== null) {
            const nestedDiff = getObjectDiff(originalValue, updatedValue);
            if (Object.keys(nestedDiff).length > 0) {
                diff[key] = nestedDiff;
            }
        }
        else if (updatedValue !== originalValue) {
            diff[key] = updatedValue;
        }
    }
    return diff;
}
